import mediaQueryListFactory from "../common/media-query-list";
import utils from '@bigcommerce/stencil-utils';

	export default function(){
        let $slider = $('.ob-category-grid.mobile-slideshow');
        let $progressBar = $slider.next('.ob-slider-progress');
        let $progressBarLabel = $progressBar.find('.slider__label');

        $slider.on('init', function(event, slick) {  
            let calc = (1 / (slick.slideCount)) * 100;
            
            $progressBar
              .css('background-size', calc + '% 100%')
              .attr('aria-valuenow', calc );
            $progressBarLabel.text( calc + '% completed' );
        });

        $slider.slick({
            "slidesToShow": 1,
		    "slidesToScroll": 1,
		    "arrows": false,
		    "dots": false,
		    "infinite": true,
		    "mobileFirst": true,
		    "swipeToSlide": true,
		    "slide": ".ob-category-card",
		    "responsive": [
		        {
		            "breakpoint": 550,
		            "settings": {
		                "slidesToShow": 2
		            }
		        },
		        {
		            "breakpoint": 801,
		            "settings": "unslick"
		        }
		    ]
        })

        let sliderLength = $slider.length - 1;

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {  
            let calc;

            if(nextSlide === sliderLength) {
                calc = 100;
            } else {
                calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
            }

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc );
            $progressBarLabel.text( calc + '% completed' );
        });
	}
